export default __webpack_public_path__ + "static/media/P6.ff34e6ae.png";